angular.module('impactx.cube').controller('CubeCtrl', CubeCtrl);
CubeCtrl.$inject = [
    '$scope',
    'CubeService',
    'NewCubeService',
    'PrintCubeService',
    'CubeConfigService',
    '$routeParams',
    '$mdDialog',
    'ToolbarService'
];

function CubeCtrl($scope, CubeService, NewCubeService, PrintCubeService, CubeConfigService, $routeParams, $mdDialog, ToolbarService) {

    var vm = this;
    this.newData = {value: false};
    this.selectedCells = {};
    this.rowSelections = 0;
    this.columnSelections = 0;

    this.showSearch = {value: true};

    vm.makeButtonDefinition = function() {
        $scope.buttonDefinition = [
            {label: vm.trns.newAnalysis, action: vm.openNew, type: 'dialogaction'},
            {label: vm.trns.refresh, action: vm.refresh, type: 'dialogaction'},
            {label: vm.trns.print, action: vm.print, type: 'dialogaction'},
            {label: vm.trns.mail, action: vm.sendMail, type: 'dialogaction'},
            {
                label: vm.trns.createGraph,
                action: vm.makeGroupBarChart,
                type: 'dialogaction',
                condition: vm.hasRowAndColumnSelected
            },
            {label: vm.trns.slice, action: vm.slice, type: 'dialogaction', condition: vm.hasSelectedCells},
            {label: vm.trns.save, action: vm.openSave, type: 'dialogaction'},
            {label: vm.trns.drillLevelColumnDown, action: vm.drillDownColumnLevel, type: 'dialogaction'},
            {label: vm.trns.drillLevelRowDown, action: vm.drillDownRowLevel, type: 'dialogaction'},
            {
                label: vm.trns.drillLevelColumnUp,
                action: vm.drillUpColumnLevel,
                type: 'dialogaction',
                condition: vm.hasColumnLevelDrillDown
            },
            {
                label: vm.trns.drillLevelRowUp,
                action: vm.drillUpRowLevel,
                type: 'dialogaction',
                condition: vm.hasRowLevelDrillDown
            }
        ];
        ToolbarService.setButtons($scope.buttonDefinition);
        ToolbarService.showDialogFilterToggle(vm.showSearch);

        // our dialog-toolbar directive relies on a data object on the scope to recalculate the buttons
        $scope.data = {};
    };

    $scope.$on("$destroy", function () {
        ToolbarService.hideDialogFilterToggle();
    });

    this.init = function () {
        if ($routeParams.id && $routeParams.id > 0) {
            if (impactX.isDefined(CubeConfigService, "selectedCube.cube")) {
                CubeConfigService.selectedCube.cube.startDate = undefined;
                CubeConfigService.selectedCube.cube.endDate = undefined;
            }
            CubeConfigService.filters = [];
            CubeService.init(vm, $routeParams.id).then(function() {
                vm.makeButtonDefinition();
                vm.showSearch.value = impactX.isDefined(CubeConfigService, "selectedCube.cube.startDate.dateValue") ||
                                impactX.isDefined(CubeConfigService, "selectedCube.cube.endDate.dateValue");
                vm.showPreSetFilters = true;
                angular.forEach(vm.data.cube.filters, function (filter) {
                    if(filter.id > 0){
                        vm.showSearch.value = true;
                    }
                });
            });
        }
        else if (CubeService.canCreateCube()) {
            CubeService.init(vm).then(function() {
                vm.makeButtonDefinition();
            })
        }
        else {
            CubeService.init(vm).then(function() {
                vm.makeButtonDefinition();
            });
            NewCubeService.open();
        }
        vm.selectedCube = CubeConfigService.selectedCube;
        vm.filters = CubeConfigService.filters;
        vm.showSearch.value = impactX.isDefined(CubeConfigService, "selectedCube.cube.startDate.dateValue") ||
                        impactX.isDefined(CubeConfigService, "selectedCube.cube.endDate.dateValue");
        if(vm.selectedCube){
            angular.forEach(vm.selectedCube.filters, function (value, key) {
                if(value){
                    vm.showSearch.value = true;
                }
            });
        }
    };

    vm.init();

    this.drillDown = function (row, column, event) {
        event.stopPropagation();
        CubeService.drillDown(vm, row, column, vm.data.columns[column].Row[row]);
        vm.resetSelection();
    };

    this.drillDownColumnLevel = function () {
        CubeService.drillDownColumnLevel(vm);
        vm.resetSelection();
    };

    this.drillDownRowLevel = function () {
        CubeService.drillDownRowLevel(vm);
        vm.resetSelection();
    };

    this.drillUp = function (row, column, event) {
        event.stopPropagation();
        CubeService.drillUp(vm, row, column, vm.data.columns[column].Row[row]);
        vm.resetSelection();
    };

    this.drillUpColumnLevel = function () {
        CubeService.drillUpColumnLevel(vm);
        vm.resetSelection();
    };

    this.drillUpRowLevel = function () {
        CubeService.drillUpRowLevel(vm);
        vm.resetSelection();
    };

    this.resetSelection = function () {
        vm.rowSelections = 0;
        vm.columnSelections = 0;
        vm.selectedCells = {};
    };

    this.hasColumnLevelDrillDown = function () {
        return CubeConfigService.columnLevelDrillDownIndex > 0;
    };

    this.hasRowAndColumnSelected = function () {
        return vm.columnSelections > 0 && vm.rowSelections > 0;
    };

    this.hasRowLevelDrillDown = function () {
        return CubeConfigService.rowLevelDrillDownIndex > 0;
    };

    this.slice = function () {
        var slices = [];
        angular.forEach(vm.selectedCells, function (cell, key) {
            slices.push({action: key, values: vm.selectedCells[key]})
        });
        CubeService.slice(vm, slices);
        vm.resetSelection();
    };

    this.refresh = function () {
        CubeService.refresh(vm);
        vm.resetSelection();
    };

    this.print = PrintCubeService.print;

    this.sendMail = CubeService.sendMail;

    this.hasSelectedCells = function () {
        return Object.keys(vm.selectedCells).length > 0
    };

    function getSliceValues(cell) {
        var action = cell.Action;
        var key = action.substring(0, action.indexOf("."))
        var values = vm.selectedCells[key];
        return {key: key, values: values};
    }

   this.selectCell = function (cell) {
       if(cell.Action){
           var sliceValues = getSliceValues(cell);
           var key = sliceValues.key;
           var values = sliceValues.values;
           if (values) {
               values.push(cell.Text);
           }
           else {
               vm.selectedCells[key] = [];
               vm.selectedCells[key].push(cell.Text)
           }
       }
    };

    this.deselectCell = function (cell) {
        if(cell.Action){
            var sliceValues = getSliceValues(cell);
            var toRemove = -1;
            angular.forEach(sliceValues.values, function (value, key) {
                if(value == cell.Text){
                    toRemove = key;
                }
            });
            if(toRemove >=0){
                vm.selectedCells[sliceValues.key].splice(toRemove,1);
                if(vm.selectedCells[sliceValues.key].length == 0){
                    delete vm.selectedCells[sliceValues.key];
                }
            }
        }
    };

    this.select = function (rowIndex, columnIndex) {
        var row = vm.data.columns[columnIndex].Row[rowIndex];
        if (row.Text && row.Text != ' ') {
            if (row.IsColumnHeader && (!vm.data.columns[columnIndex].Row[rowIndex + 1].Text || vm.data.columns[columnIndex].Row[rowIndex + 1].Text == ' ')) {
                var column = vm.data.columns[columnIndex];
                while (rowIndex < column.Row.length) {
                    var cell = column.Row[rowIndex];
                    var selector = '#' + rowIndex + '\\.' + columnIndex;
                    var domElement = $(selector);
                    if (cell.isColumnSelected) {
                        cell.columnSelector = null;
                        cell.isColumnSelected = false;
                        if (cell.isRowSelected === true)
                        {
                            domElement.removeClass("CubeBothSelected");
                            domElement.addClass("CubeRowSelected");
                        }
                        else
                        {
                            domElement.removeClass("CubeColumnSelected");
                        }
                        vm.columnSelections--;
                        vm.deselectCell(cell);
                    }
                    else {
                        cell.columnSelector = row.Text;
                        cell.isColumnSelected = true;
                        if (cell.isRowSelected === true)
                        {
                            domElement.addClass("CubeBothSelected");
                            domElement.removeClass("CubeRowSelected");
                        }
                        else
                        {
                            domElement.addClass("CubeColumnSelected");
                        }
                        vm.selectCell(cell);
                        vm.columnSelections++;
                    }
                    rowIndex++;
                }
            }
            if (row.IsRowHeader && !row.IsMeasure) {
                while (columnIndex < vm.data.columns.length) {
                    var cell = vm.data.columns[columnIndex].Row[rowIndex];
                    var selector = '#' + rowIndex + '\\.' + columnIndex;
                    var domElement = $(selector);

                    if (cell.isRowSelected) {
                        cell.isRowSelected = false;
                        cell.rowSelector = row.Text;
                        if (cell.isColumnSelected === true)
                        {
                            domElement.removeClass("CubeBothSelected");
                            domElement.addClass("CubeColumnSelected");
                        }
                        else
                        {
                            domElement.removeClass("CubeRowSelected");
                        }
                        vm.deselectCell(cell);
                        vm.rowSelections--;
                    }
                    else {
                        cell.isRowSelected = true;
                        cell.rowSelector = row.Text;
                        if (cell.isColumnSelected === true)
                        {
                            domElement.addClass("CubeBothSelected");
                            domElement.removeClass("CubeColumnSelected");

                        }
                        else
                        {
                            domElement.addClass("CubeRowSelected");
                        }
                        vm.selectCell(cell);
                        vm.rowSelections++;
                    }
                    columnIndex++;
                }
            }
        }
    };

    this.makeGroupBarChart = function () {
        var anchorSelector = ".chartAnchor";
        var array = [];
        for (var i = 0; i < vm.data.columns.length; i++) {
            var column = vm.data.columns[i];
            var newColumn = true;
            var obj = {};
            for (var j = 0; j < column.Row.length; j++) {
                if (column.Row[j].Value && column.Row[j].isColumnSelected && column.Row[j].isRowSelected) {
                    if (newColumn) {
                        obj = {};
                        obj.label = column.Row[j].columnSelector;
                    }
                    obj[column.Row[j].rowSelector] = parseFloat(column.Row[j].Value.replaceAll(',', '').replaceAll(".", '')) / 100.0;
                    if (newColumn) {
                        array.push(obj);
                        newColumn = false;
                    }
                }

            }
        }
        $(anchorSelector).find("svg").remove();
        if (array.length > 0) {
            makeGroupedBarChart(anchorSelector, array);
        }
    };

    this.toggleSearch = function () {
        vm.showSearch.value = !vm.showSearch.value;

    };

    vm.openNew = NewCubeService.open;

    vm.openSave = function (ev) {
        $mdDialog.show({
            controller: "SaveCubeCtrl",
            controllerAs: "saveCubeCtrl",
            templateUrl: './modules/cube/templates/savecube.tmpl.html',
            locals: {
                trns: vm.trns,
                cube: CubeConfigService.selectedCube
            },
            targetEvent: ev,
            clickOutsideToClose: true,
            hasBackdrop: true,
            disableParentScroll: false
        });

    };
}

//todo: do this with nvd3
function makeGroupedBarChart(anchor, data) {
    var margin = {top: 20, right: 20, bottom: 30, left: 40},
        width = 1100 - margin.left - margin.right,
        height = 500 - margin.top - margin.bottom;

    var x0 = d3.scale.ordinal()
        .rangeRoundBands([0, width - 200], .1);

    var x1 = d3.scale.ordinal();

    var y = d3.scale.linear()
        .range([height, 0]);

    var color = d3.scale.category20();

    var xAxis = d3.svg.axis()
        .scale(x0)
        .orient("bottom");

    var yAxis = d3.svg.axis()
        .scale(y)
        .orient("left")
        .tickFormat(d3.format(".2s"));

    var svg = d3.select(anchor).append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    svg.data(data);
    var ageNames = d3.keys(data[0]).filter(function (key) {
        return key !== "label";
    });

    data.forEach(function (d) {
        d.labels = ageNames.map(function (name) {
            return {name: name, value: +d[name]};
        });
    });

    x0.domain(data.map(function (d) {
        return d.label;
    }));
    x1.domain(ageNames).rangeRoundBands([0, x0.rangeBand()]);
    y.domain([0, d3.max(data, function (d) {
        return d3.max(d.labels, function (d) {
            return d.value;
        });
    })]);

    svg.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis);

    svg.append("g")
        .attr("class", "y axis")
        .call(yAxis)
        .append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", ".71em")
        .style("text-anchor", "end");

    var state = svg.selectAll(".state")
        .data(data)
        .enter().append("g")
        .attr("class", "g")
        .attr("transform", function (d) {
            return "translate(" + (x0(d.label)) + ",0)";
        });

    state.selectAll("rect")
        .data(function (d) {
            return d.labels;
        })
        .enter().append("rect")
        .attr("width", Math.min(x1.rangeBand(), 100))
        .attr("x", function (d, i) {

            if (x1.rangeBand() > 100) {
                return 100 * i + ((x1.rangeBand() - 100) / 2) * ageNames.length;
            }
            else {
                return x1(d.name);
            }
        })
        .attr("y", function (d) {
            return y(d.value);
        })
        .attr("height", function (d) {
            return height - y(d.value);
        })
        .style("fill", function (d) {
            return color(d.name);
        });

    var legend = svg.selectAll(".legend")
        .data(ageNames.slice())
        .enter().append("g")
        .attr("class", "legend")
        .attr("transform", function (d, i) {
            return "translate(0," + i * 20 + ")";
        });

    legend.append("rect")
        .attr("x", width - 190)
        .attr("width", 18)
        .attr("height", 18)
        .style("fill", color);

    legend.append("text")
        .attr("x", width - 170)
        .attr("y", 9)
        .attr("dy", ".35em")
        .text(function (d) {
            var s = d;
            if (d.length > 30) {
                s = d.substring(0, 30) + "...";
            }
            return s;
        });
}